<app-nav></app-nav>
<section class="personalAccidentProposal" *ngIf="!thankyouSection && !transactionFailureSection">
  <div class="container">
    <div class="col">
      <h4 class="form-title">Proposer's Details</h4>
      <form name="form" (ngSubmit)="f.form.valid" #personalForm="ngForm">
        <div class="row">
          <div class="col-2" style="padding-right:0px;">
            <p class="title mendatory">Title</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <select class="form-control" name="title" [(ngModel)]="f.title" id="title" #title="ngModel" required>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Dr">Dr</option>
                  <option value="Adv">Adv</option>
                  <option value="M/S">M/S</option>
                </select>
                <div *ngIf="title.invalid && title.touched " class="error-message">
                  <div *ngIf="title.errors.required">
                    Title is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-5">
            <p class="title mendatory">First Name</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="text" name="fName" [(ngModel)]="f.firstName" id="fName"
                  #fName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                <div *ngIf="fName.invalid && fName.touched " class="error-message">
                  <div *ngIf="fName.errors.required">
                    First Name is required.
                  </div>
                  <div *ngIf="fName.errors.pattern">
                    Please enter valid First name.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-5">
            <p class="title mendatory">Last Name</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="text" name="lName" [(ngModel)]="f.lastName" id="lName"
                  #lName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                <div *ngIf="lName.invalid && lName.touched " class="error-message">
                  <div *ngIf="lName.errors.required">
                    Last Name is required.
                  </div>
                  <div *ngIf="lName.errors.pattern">
                    Please enter valid Last name.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="title mendatory">Mobile No.</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input type="text" #mobile="ngModel" name="mobile" id="mobile" class="form-control"
                  placeholder="Mobile No." [(ngModel)]="f.mobile" #mobile1="ngModel" maxlength="10" minlength="10"
                  (keydown.space)="$event.preventDefault();" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric"
                  required>
                <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
                  <div *ngIf="mobile.errors.required">
                    Mobile number is required.
                  </div>
                  <div *ngIf="mobile.errors.maxlength">
                    Mobile number should not be greater than 10 digits.
                  </div>
                  <div *ngIf="mobile.errors.minlength">
                    Mobile number must be at least 10 digits long.
                  </div>
                  <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                    Invalid mobile number.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <p class="title mendatory">Gender</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <select class="form-control" name="gender" [(ngModel)]="f.gender" id="gender" #gender="ngModel"
                  required>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <div *ngIf="gender.invalid && gender.touched " class="error-message">
                  <div *ngIf="gender.errors.required">
                    Gender is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="title mendatory">E-mail Address</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="email" name="email" id="email" #email="ngModel" [(ngModel)]="f.email"
                  [email]="true" maxlength="100" required>
                <div *ngIf="email.invalid && email.touched " class="error-message">
                  <div *ngIf="email.errors.required">
                    Email Address is required.
                  </div>
                  <div *ngIf="email.errors.email">
                    Please enter correct Email address.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12">
            <p class="title mendatory">Address</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="text" name="address1" [(ngModel)]="f.address1" id="address1"
                  #address1="ngModel" maxlength="500" required>
                <div *ngIf="address1.invalid && address1.touched " class="error-message">
                  <div *ngIf="address1.errors.required">
                    Address is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <p class="title mendatory">Pin Code</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="number" name="pinCode" [(ngModel)]="f.pincode"
                  (keydown.space)="$event.preventDefault();" (keypress)="keyPress($event)"
                  (focusout)="getCityStateList(f.pincode)" maxlength="6" minlength="6" id="pinCode" #pinCode="ngModel"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  required>
                <div *ngIf="invalidPincode" class="error-message">
                  Invalid pincode.
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <p class="title mendatory">City</p>
            <div class="sum-insured-input">
              <select name="city" class="form-control quote-dropdown" id="city" name="city" [(ngModel)]="f.city"
                #city="ngModel" required>
                <option *ngFor="let city of cityList" value="{{city}}">{{city | uppercase}}</option>
              </select>
              <div *ngIf="city.invalid && city.touched " class="error-message">
                <div *ngIf="city.errors.required">
                  City is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="title mendatory">State</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="text" name="stateList" [(ngModel)]="f.state" disabled>
              </div>
            </div>
          </div>
        </div>

        <!-- Insured's Details Starts -->
        <h4 class="form-title">Insured's Details</h4>
        <div class="row">
          <div class="col-2" style="padding-right:0px;">
            <p class="title mendatory">Title</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <select class="form-control" name="insuredTitle" [(ngModel)]="f.insuredTitle" id="insuredTitle" #insuredTitle="ngModel" required>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Dr">Dr</option>
                  <option value="Adv">Adv</option>
                  <option value="M/S">M/S</option>
                </select>
                <div *ngIf="title.invalid && title.touched " class="error-message">
                  <div *ngIf="title.errors.required">
                    Title is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-5">
            <p class="title mendatory">First Name</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="text" name="fInsuredName" [(ngModel)]="f.insuredFirstName" id="fInsuredName"
                  #fInsuredName="ngModel" pattern="[a-zA-Z]+" maxlength="200" required>
                <div *ngIf="fInsuredName.invalid && fInsuredName.touched " class="error-message">
                  <div *ngIf="fName.errors.required">
                    First Name is required.
                  </div>
                  <div *ngIf="fInsuredName.errors.pattern">
                    Please enter valid First name.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-5">
            <p class="title mendatory">Last Name</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="text" name="lInsuredName" [(ngModel)]="f.insuredLastName" id="lInsuredName"
                  #lInsuredName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                <div *ngIf="lInsuredName.invalid && lInsuredName.touched " class="error-message">
                  <div *ngIf="lInsuredName.errors.required">
                    Last Name is required.
                  </div>
                  <div *ngIf="lInsuredName.errors.pattern">
                    Please enter valid Last name.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="title mendatory">Relationship with Proposer</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <select class="form-control" id="insuredRelation" name="insuredRelation" [(ngModel)]="f.insuredRelation"
                  id="insuredRelation" #insuredRelation="ngModel" required>
                  <option value="" selected="selected" disabled="">Insured Relation</option>
                  <option value="Brother">Brother</option>
                  <option value="Brother in Law">Brother in Law</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Father">Father</option>
                  <option value="Grand Father">Grand Father</option>
                  <option value="Grand Mother">Grand Mother</option>
                  <option value="Husband">Husband</option>
                  <option value="Mother">Mother</option>
                  <option value="Mother in Law">Mother in Law</option>
                  <option value="Sister">Sister</option>
                  <option value="Sister in Law">Sister in Law</option>
                  <option value="Son">Son</option>
                  <option value="Wife">Wife</option>
                  <option value="Self">Self</option>
                </select>
                <div *ngIf="insuredRelation.invalid && insuredRelation.touched " class="error-message">
                  <div *ngIf="insuredRelation.errors.required">
                    Insured relation is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <p class="title mendatory">DOB</p>
            <div class="sum-insured-input reg-date-input proposal-date-input">
              <div class="input-group">
                <div class="input-group addon">
                  <img
                    src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                  <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="f.insuredDob" dateFormat="dd/mm/yy"
                    [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2020" placeholder="Date"
                    name="regDate" [maxDate]="value" (onBlur)="checkValueInsured()" (onSelect)="calculateAgeInsured()" keepInvalid
                    [required]="true"></p-calendar>
                  <span class="input-group-addon" id="basic-addon-dueDate"></span>
                </div>
              </div>
              <div *ngIf="insuredShouldBe18" class="error-message">
                Date of birth should be greater than 18.
              </div>
              <div *ngIf="insuredDOBrequired" class="error-message">
                Date of Birth is required.
              </div>
            </div>
          </div>
          <div class="col-6">
            <p class="title mendatory">Gender</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <select class="form-control" name="insuredGender" [(ngModel)]="f.insuredGender" id="insuredGender" #insuredGender="ngModel"
                  required>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <div *ngIf="insuredGender.invalid && insuredGender.touched " class="error-message">
                  <div *ngIf="insuredGender.errors.required">
                    Gender is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Insured's Details Ends -->
        <!-- Nominee Details Starts -->
        <h4 class="form-title">Nominee Details</h4>
        <div class="row">
          <div class="col-12">
            <p class="title mendatory">Nominee Name</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <input class="form-control" type="text" name="nomineeName" [(ngModel)]="f.nomineeName" id="nomineeName"
                  #nomineeName="ngModel" pattern="[a-zA-Z\s]+" maxlength="200" required>
                <div *ngIf="nomineeName.invalid && nomineeName.touched " class="error-message">
                  <div *ngIf="nomineeName.errors.required">
                    Nominee name is required.
                  </div>
                  <div *ngIf="nomineeName.errors.pattern">
                    Please enter valid Nominee name.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="title mendatory">Relationship with Proposer</p>
            <div class="sum-insured-input">
              <div class="form-group">
                <select class="form-control" id="nomineeRelation" name="nomineeRelation" [(ngModel)]="f.nomineeRelation"
                  id="nomineeRelation" #nomineeRelation="ngModel" required>
                  <option value="" selected="selected" disabled="">Nominee Relation</option>
                  <option value="Brother">Brother</option>
                  <option value="Brother in Law">Brother in Law</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Father">Father</option>
                  <option value="Grand Father">Grand Father</option>
                  <option value="Grand Mother">Grand Mother</option>
                  <option value="Husband">Husband</option>
                  <option value="Mother">Mother</option>
                  <option value="Mother in Law">Mother in Law</option>
                  <option value="Sister">Sister</option>
                  <option value="Sister in Law">Sister in Law</option>
                  <option value="Son">Son</option>
                  <option value="Wife">Wife</option>
                  <option value="Self">Self</option>
                </select>
                <div *ngIf="nomineeRelation.invalid && nomineeRelation.touched " class="error-message">
                  <div *ngIf="nomineeRelation.errors.required">
                    Nominee relation is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <p class="title mendatory">DOB</p>
            <div class="sum-insured-input reg-date-input proposal-date-input">
              <div class="input-group">
                <div class="input-group addon">
                  <img
                    src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                  <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="f.nomineeDob" dateFormat="dd/mm/yy"
                    [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2020" placeholder="Date"
                    name="regDate" [maxDate]="value" (onBlur)="checkValueNominee()" (onSelect)="calculateAgeNominee()" keepInvalid
                    [required]="true"></p-calendar>
                  <span class="input-group-addon" id="basic-addon-dueDate"></span>
                </div>
              </div>
              <div *ngIf="nomineeShouldBe18" class="error-message">
                Date of birth should be greater than 18.
              </div>
              <div *ngIf="nomineeDOBrequired" class="error-message">
                Date of Birth is required.
              </div>
            </div>
          </div>
        </div>

        <!-- Nominee Details Ends -->
        <div class="row mt-4">
          <!-- <div class="col-6">
            <button class="btn btn-bordered-blue">Save</button>
          </div>
          <div class="col-6">
            <button class="btn btn-bordered-blue" (click)="openModal(template);">Proceed</button>
          </div> -->
          <div class="col-12 text-center">
            <button class="btn btn-bordered-blue" (click)="openModal(template);"
              [disabled]="personalForm.form.invalid" id="proceedPayment">Proceed</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
  <ng-template #template>
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body">
        <div class="col">
          <h4 class="modal-title">Terms & Conditions</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      
        <div class="col mt-4">
          <div class="checkbox" *ngIf="!environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://pamstaging2.securenow.in/terms-conditions" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox" *ngIf="environment.production">
            <label><input type="checkbox" name="termCheck" id="termCheck" name="termCheck" [(ngModel)]="f.termCheck"
                #termCheck="ngModel" required> I hereby agree to the <a
                href="https://securenow.in/terms-conditions" target="_blank">terms &amp;
                conditions</a> of the purchase of this policy.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck2" name="termCheck2" [(ngModel)]="f.termCheck2"
                #termCheck2="ngModel" required> I hereby agree that the insured does not have any 
                Pre-Existing Disease(COVID related).</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck3" name="termCheck3" [(ngModel)]="f.termCheck3"
                #termCheck3="ngModel" required> I hereby agree that the insured did not travel to 
                foreign countries in the last 45 days.</label>
          </div>
          <div class="checkbox">
            <label><input type="checkbox" name="termCheck" id="termCheck4" name="termCheck4" [(ngModel)]="f.termCheck4"
                #termCheck4="ngModel"> I hereby agree that insured is neither living with a Covid19 diagnosed person nor any 
                of the insured's family member has ever been detected positive with COVID 19.</label>
          </div>          
        </div>

        <div class="col text-center mt-4">
          <button class="btn btn-bordered-blue" aria-label="Close" (click)="modalRef.hide();submitProposalFormData()"
            [disabled]="f.form.invalid">Pay</button>
        </div>
      </div>
    </form>
  </ng-template>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<section class="personalAccidentProposalThankYou" *ngIf="thankyouSection">
  <div class="container">
    <div class="col">
      <h4 class="payment-title text-center mt-4">Payment Successful</h4>
      <div class="insurer-image text-center mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png"
          class="img-responsive" width="50%" alt="Religare Insurance">
      </div>
    </div>
    <div class="col download-document">
      <div class="insurer-image text-center">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/file-4.svg"
          class="img-responsive" width="20%" alt="Download Document">
      </div>
      <h4 class="download-title text-center mt-3">Download Policy Document</h4>
    </div>
    <div class="col contact-us text-center">
      <p class="title">For Endorsement and Claim Contact at:</p>
      <p class="call"><img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone.svg"><span>1860-500-4488</span><span
          class="bar"></span><span>1800-102-4488</span></p>
      <p class="call"><span><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/message.svg"></span>customerfirst@religarehealthinsurance.com
      </p>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
</section>
<section class="personalAccidentTransactionFailure" *ngIf="transactionFailureSection">
  <div class="container">
    <div class="col text-center failure-error">

      <div class="insurer-image mt-4">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg"
          class="img-responsive" width="20%" alt="Error">
      </div>
      <h4 class="payment-title mt-4">Oops... Payment Failed</h4>
      <p class="error-message">{{errorStatus}}</p>
      <p class="error-message">{{errorInternalMsg}}</p>
      <!-- <p>Transaction Id: 778W990</p> -->
    </div>
    <div class="col failure-reasons">
      <ul class="oval">
        <li>The Card CVV or Expiry Date might be wrong</li>
        <li>Your Bank networks might be down</li>
      </ul>
      <div class="text-center mt-4">
        <button class="btn btn-bordered-blue">Try Again</button>
      </div>
    </div>
    <div class="col footer-strip text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
      <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
